import { useFormik } from "formik";
import { Button } from "primereact/button";
import { DefaultTextFieldComponent } from "@components/DefaultTextInput";
import { ValidatedField } from "@components/ValidatedField";
import { useTranslation } from "@i18n/hooks";
import {
	type AccountsTableFilterProps,
	type AccountsTableFilterState,
} from "./accounts-table-filter.interface";

export const AccountsTableFilter = ({ refetch }: AccountsTableFilterProps) => {
	const { t } = useTranslation("common");
	const initialValues = {};

	const formik = useFormik<AccountsTableFilterState>({
		initialValues,
		onSubmit: (values, { setSubmitting }) => {
			refetch(values.name);
			setSubmitting(false);
		},
	});

	const clearForm = () => {
		formik.handleReset(initialValues);
		formik.handleSubmit();
	};

	return (
		<form onSubmit={formik.handleSubmit} className="p-fluid">
			<div className="flex flex-row align-items-center">
				<ValidatedField<AccountsTableFilterState, string>
					name="name"
					label={t("accounts.name")}
					className="mr-2 w-25rem"
					component={DefaultTextFieldComponent}
					formikConfig={formik}
				/>
				<Button
					disabled={false}
					type="reset"
					onClick={clearForm}
					icon="pi pi-times"
					className="h-3rem w-3rem"
					aria-label={t("actions.clear")}
				/>
				<Button
					disabled={false}
					type="submit"
					icon="pi pi-search"
					className="h-3rem w-3rem ml-2"
					aria-label={t("actions.search")}
				/>
			</div>
		</form>
	);
};
